import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/demand/integrations')({
  component: IntegrationsLayout,
});

function IntegrationsLayout() {
  return <Outlet />;
}
